module.exports = __webpack_public_path__ + "img/logo-slu.26f4e426.png";